let config;

const environments = {
  local: {
    name: 'Local development',
    code: 'dev',
    ws: {
      apiHost: 'https://insight-service-dev.xonar.com',
      webSocketHost: 'https://insight-service-dev.xonar.com',
      context: 'insight',
      pythonApiHost: 'https://insightdev-python.xonar.com',
      insight2Host: 'https://insight2dev.xonar.com'
    },
    frontEndUrl: 'https://insightdev.xonar.com',
    authRedirectUrl: 'https://insightdev.xonar.com/auth/login'
  },

  uat: {
    name: 'UAT',
    code: 'uat',
    ws: {
      apiHost: 'https://api.insight-uat.xonar.com',
      webSocketHost: 'https://api.insight-uat.xonar.com',
      context: 'insight',
      pythonApiHost: 'https://insightuat-python.xonar.com',
      insight2Host: 'https://insight2uat.xonar.com'
    },
    frontEndUrl: 'https://insight-uat.xonar.com',
    authRedirectUrl: 'https://insight-uat.xonar.com/auth/login'
  },

  production: {
    name: 'Production',
    code: 'prod',
    ws: {
      apiHost: 'https://insight-service.xonar.com',
      webSocketHost: 'https://insight-service.xonar.com',
      context: 'insight',
      pythonApiHost: 'https://insight-python.xonar.com',
      insight2Host: 'https://insight2.xonar.com'
    },
    frontEndUrl: 'https://insight.xonar.com',
    authRedirectUrl: 'https://insight.xonar.com/auth/login'
  }
};

export default class Configuration {
  static getConfig() {
    if (config === undefined) {
      const envCode = this.retrieveMetaEnvCode();
      if (envCode === '_ENVIRONMENT_') {
        /* The environment has not been configured in meta tag, use local as a default */
        config = environments.local;
      } else {
        config = environments[envCode];
      }
    }
    return {
      ...config,
      authClientId:
        '22289539476-s5tuv7qa7i2dpfkb5mnnrahumd58ec7r.apps.googleusercontent.com'
    };
  }

  static retrieveMetaEnvCode() {
    const metas = document.getElementsByTagName('meta');

    let envCode;
    for (let i = 0; i < metas.length; i++) {
      if (metas[i].getAttribute('name') === 'env') {
        envCode = metas[i].getAttribute('content');
        break;
      }
    }

    return envCode;
  }
}
